export enum UserFetchStatus {
  LoadingFromStorage,
  Loading,
  Loaded,
  Removed,
  Expired,
  Error,
}
